module.exports = __webpack_public_path__ + "static/media/instagram.74b11813.svg";